import * as Actions from '../../actions';

const initialState = { data: null };

const viewDropoffsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DROPOFF_DETAILS:
            return { ...state, data: { ...action.payload } };
        case Actions.GET_HAULING_DROPOFF_DETAILS:
            return { ...state, data: { ...action.payload } };
        case Actions.GET_PROCESSOR_DROPOFF_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default viewDropoffsReducer;
